var _effectorFileName = "/builds/gmini/front-common/src/hooks/useReadonlyMode.ts";
import { createContext, useContext, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Mode = /*#__PURE__*/createContext(null);
export var ReadonlyModeProvider = Mode.Provider;
export function useReadonlyMode() {
  var readonlyMode = useContext(Mode);
  return useMemo(function () {
    return {
      readonlyMode: readonlyMode
    };
  }, [readonlyMode]);
}